import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import find from 'lodash/find';
import get from 'lodash/get';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import App from 'modules/App';
import Account from 'modules/Account';
import Information from 'modules/Information';
import FormGroup from 'components/Form/FormGroup';
import Select from 'components/Form/Select';
import { usePatientProfileForm } from '../hooks';
const desiredOrder = [
    'NoResponse',
    'Male',
    'Female'
];
const Gender = ()=>{
    const localizationResources = useSelector(App.selectors.localizationResources);
    const informationTemplate = useSelector(Information.selectors.informationTemplate);
    const field = find(informationTemplate, {
        name: 'gender'
    });
    const { formValues, setFormValue } = usePatientProfileForm();
    const options = map(field.options, ({ value, labelKey })=>({
            value,
            label: get(localizationResources, `${labelKey}.value`, value)
        }));
    const sortedOptions = sortBy(options, (item)=>{
        const index = desiredOrder.indexOf(item.value);
        return index === -1 ? Number.MAX_SAFE_INTEGER : index;
    });
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: "gender",
        labelMessage: Account.messages.labels.gender,
        formValues: formValues,
        children: /*#__PURE__*/ _jsx(Select, {
            optionsFrom: sortedOptions,
            valueKey: "value",
            labelKey: "label",
            onChange: setFormValue
        })
    });
};
export default Gender;
